import { useState } from 'react';

export function BundleTooltip({ content, children }) {
  const [visible, setVisible] = useState(false);
  return (
    <span className="relative inline-block">
      <span
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
        className="cursor-help"
      >
        {children}
      </span>
      {visible && (
        <span className="absolute z-20 w-64 px-3 py-2 text-xs bg-popover text-popover-foreground rounded-md shadow-lg border border-border -mt-1 transform -translate-y-full left-1/2 -translate-x-1/2 pointer-events-none">
          {content}
          <span className="absolute w-2 h-2 bg-popover border-r border-b border-border transform rotate-45 left-1/2 -translate-x-1/2 -bottom-1" />
        </span>
      )}
    </span>
  );
}
